import { render, staticRenderFns } from "./SchoolTrips.html?vue&type=template&id=2088a91a&scoped=true&external"
import script from "./SchoolTrips.js?vue&type=script&lang=js&external"
export * from "./SchoolTrips.js?vue&type=script&lang=js&external"
import style0 from "./SchoolTrips.vue?vue&type=style&index=0&id=2088a91a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2088a91a",
  null
  
)

export default component.exports